module.exports = __webpack_public_path__ + "static/media/zoominLogo.7f02627a.svg";